export default __webpack_public_path__ + "static/card-as-a-service-9d78184f47adbd0078dd3bb1a4ccd51f.png";